export const ArraySort = (data = [], orderBy = '', orderDirection = 'desc') => {
  const compare = (a, b) => {
    if (!a[orderBy] || !b[orderBy]) {
      return 0
    }
    return a[orderBy].localeCompare(b[orderBy])
  }

  const compareSite = (a, b) => {
    const {
      site: site_a = '',
      building_name: building_a = '',
      floor_name: floor_a = '',
    } = a
    const {
      site: site_b = '',
      building_name: building_b = '',
      floor_name: floor_b = '',
    } = b
    const localSite = site_a?.name.localeCompare(site_b?.name)
    if (localSite === 0) {
      const localBuilding = building_a.localeCompare(building_b)
      if (localBuilding === 0) {
        return floor_a.localeCompare(floor_b)
      } else {
        return localBuilding
      }
    } else {
      return localSite
    }
  }

  return data.sort((a, b) => {
    if (orderDirection === 'desc') {
      if (orderBy === 'site_name') {
        return compareSite(a, b)
      } else {
        return compare(a, b)
      }
    } else {
      if (orderBy === 'site_name') {
        return compareSite(b, a)
      } else {
        return compare(b, a)
      }
    }
  })
}

export const tableFilters = ({
  item,
  search,
  reachable = null,
  buildingName = null,
  floorName = null,
}) => {
  if (item.label && item.label.toLowerCase().includes(search.toLowerCase())) {
    return filterColumn(item, [
      {
        name: 'is_reachable',
        value: reachable,
      },
      {
        name: 'building_name',
        value: buildingName,
      },
      {
        name: 'floor_name',
        value: floorName,
      },
    ])
  }
  return false
}

const filterColumn = (equipment, filters) => {
  if (!equipment) {
    return false
  }
  for (const filter of filters) {
    if (filter.value !== null && equipment[filter.name] !== filter.value) {
      return false
    }
  }
  return true
}

export const accessPointsToSSIDs = (equipments) => {
  return equipments
    .filter(({ site }) => Boolean(site))
    .reduce((acc, equipment) => {
      (equipment.ssid_names || []).forEach((ssid) => {
        let index = acc.findIndex(
          ({ site }) => site.id === equipment.site?.id,
        );
        if (index === -1) {
          acc = [...acc, { site: equipment.site, ssids: [] }];
          index = acc.length - 1;
        }
        const indexSsid = acc[index].ssids.findIndex(
          ({ name }) => ssid === name,
        );
        if (indexSsid > -1) {
          acc[index].ssids[indexSsid].equipments = [
            ...acc[index].ssids[indexSsid].equipments,
            equipment,
          ];
        } else {
          acc[index].ssids = [
            ...acc[index].ssids,
            { name: ssid, equipments: [equipment] },
          ];
        }
      });
      return acc;
    }, [])
    .map(({ site, ssids }) =>
      ssids.map((ssid) => ({
        ...ssid,
        site: { id: site.id, name: site.name, sf_id: site.sf_id },
      })),
    )
    .flat();
}

export const normalizeString = (str) => {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

